import classNames from 'classnames'
import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import React from 'react'


const EmptyHolder = ({
                         style,
                         className,
                         iconSize = 64,
                         icon = () => (
                             <svg width="100%" viewBox="0 0 680 320" style={{maxWidth: 480}} xmlns="http://www.w3.org/2000/svg">
                                 {/* Clouds */}
                                 <ellipse cx="120" cy="70" rx="35" ry="16" fill="#e8e4dc"/>
                                 <ellipse cx="148" cy="62" rx="28" ry="20" fill="#e8e4dc"/>
                                 <ellipse cx="95" cy="68" rx="22" ry="13" fill="#e8e4dc"/>
                                 <ellipse cx="530" cy="55" rx="28" ry="12" fill="#e8e4dc"/>
                                 <ellipse cx="554" cy="48" rx="22" ry="16" fill="#e8e4dc"/>
                                 <ellipse cx="510" cy="54" rx="18" ry="10" fill="#e8e4dc"/>
                                 {/* Stars */}
                                 <circle cx="200" cy="45" r="2" fill="#c8a84b"/>
                                 <circle cx="470" cy="38" r="2.5" fill="#c8a84b"/>
                                 <circle cx="440" cy="65" r="1.5" fill="#c8a84b"/>
                                 <circle cx="230" cy="80" r="1.5" fill="#c8a84b"/>
                                 {/* Church body */}
                                 <rect x="270" y="140" width="140" height="100" rx="2" fill="#f0ebe0" stroke="#d0c8b8"
                                       strokeWidth="0.5"/>
                                 {/* Tower */}
                                 <rect x="314" y="100" width="52" height="60" rx="2" fill="#e8e0d0" stroke="#d0c8b8" strokeWidth="0.5"/>
                                 {/* Roof */}
                                 <polygon points="304,100 376,100 340,65" fill="#8b3a3a"/>
                                 {/* Cross */}
                                 <line x1="340" y1="50" x2="340" y2="70" stroke="#c8a84b" strokeWidth="3" strokeLinecap="round"/>
                                 <line x1="330" y1="57" x2="350" y2="57" stroke="#c8a84b" strokeWidth="3" strokeLinecap="round"/>
                                 {/* Tower windows */}
                                 <rect x="328" y="112" width="12" height="18" rx="6" fill="#b8d4e8" stroke="#90b0c8" strokeWidth="0.5"/>
                                 <rect x="344" y="112" width="12" height="18" rx="6" fill="#b8d4e8" stroke="#90b0c8" strokeWidth="0.5"/>
                                 {/* Rose window */}
                                 <circle cx="340" cy="164" r="14" fill="none" stroke="#d0c8b8" strokeWidth="0.5"/>
                                 <circle cx="340" cy="164" r="10" fill="#c8d8e8" stroke="#90b0c8" strokeWidth="0.5"/>
                                 <line x1="340" y1="154" x2="340" y2="174" stroke="#a0b8c8" strokeWidth="0.5"/>
                                 <line x1="330" y1="164" x2="350" y2="164" stroke="#a0b8c8" strokeWidth="0.5"/>
                                 {/* Door */}
                                 <rect x="324" y="196" width="32" height="44" rx="16" fill="#4a3020" stroke="#3a2418" strokeWidth="0.5"/>
                                 <path d="M324,210 Q340,196 356,210" fill="none" stroke="#6a4a30" strokeWidth="0.5"/>
                                 {/* Side windows */}
                                 <rect x="282" y="160" width="14" height="20" rx="7" fill="#b8d4e8" stroke="#90b0c8" strokeWidth="0.5"/>
                                 <rect x="384" y="160" width="14" height="20" rx="7" fill="#b8d4e8" stroke="#90b0c8" strokeWidth="0.5"/>
                                 {/* Magnifying glass */}
                                 <circle cx="430" cy="195" r="26" fill="none" stroke="#9a9a9a" strokeWidth="3"/>
                                 <line x1="449" y1="214" x2="465" y2="230" stroke="#9a9a9a" strokeWidth="4" strokeLinecap="round"/>
                                 <line x1="421" y1="186" x2="439" y2="204" stroke="#c0a0a0" strokeWidth="2" strokeLinecap="round"/>
                                 <line x1="439" y1="186" x2="421" y2="204" stroke="#c0a0a0" strokeWidth="2" strokeLinecap="round"/>
                                 {/* Ground */}
                                 <line x1="200" y1="240" x2="480" y2="240" stroke="#d8d0c0" strokeWidth="1" strokeDasharray="4,4"/>
                                 {/* Bushes */}
                                 <ellipse cx="262" cy="238" rx="18" ry="10" fill="#7a9a6a"/>
                                 <ellipse cx="250" cy="234" rx="12" ry="8" fill="#8aaa7a"/>
                                 <ellipse cx="418" cy="238" rx="18" ry="10" fill="#7a9a6a"/>
                                 <ellipse cx="430" cy="234" rx="12" ry="8" fill="#8aaa7a"/>
                             </svg>
                         ),
                         title,
                         subTitle = "No data available",
                         children,
                     }) => {
    const t = useTranslate();


    return (
        <div
            style={style}
            className={classNames(
                "pb-8 pt-6 px-4 m-3 flex flex-col space-y-2 items-center m-auto max-w-2xl text-center",
                className
            )}
        >
            {icon && icon()}
            {title && (
                <div className="font-semibold text-base text-gray-700 tracking-wide leading-snug">
                    {_.isString(title) ? t(title) : _.isFunction(title) ? title() : title}
                </div>
            )}
            {subTitle && (
                <div className="text-sm text-gray-500 tracking-wider leading-tight italic">
                    {_.isString(subTitle)
                        ? t(subTitle)
                        : _.isFunction(subTitle)
                            ? subTitle()
                            : subTitle}
                </div>
            )}
            {!!children && children}
        </div>
    );
};


export const EmptySearchState = () => {
    const t = useTranslate()
    return (
        <div className="flex flex-col items-center justify-center py-8">
            <svg width="100%" viewBox="0 0 680 320" style={{maxWidth: 480}} xmlns="http://www.w3.org/2000/svg">
                {/* Clouds */}
                <ellipse cx="120" cy="70" rx="35" ry="16" fill="#e8e4dc"/>
                <ellipse cx="148" cy="62" rx="28" ry="20" fill="#e8e4dc"/>
                <ellipse cx="95" cy="68" rx="22" ry="13" fill="#e8e4dc"/>
                <ellipse cx="530" cy="55" rx="28" ry="12" fill="#e8e4dc"/>
                <ellipse cx="554" cy="48" rx="22" ry="16" fill="#e8e4dc"/>
                <ellipse cx="510" cy="54" rx="18" ry="10" fill="#e8e4dc"/>
                {/* Stars */}
                <circle cx="200" cy="45" r="2" fill="#c8a84b"/>
                <circle cx="470" cy="38" r="2.5" fill="#c8a84b"/>
                <circle cx="440" cy="65" r="1.5" fill="#c8a84b"/>
                <circle cx="230" cy="80" r="1.5" fill="#c8a84b"/>
                {/* Church body */}
                <rect x="270" y="140" width="140" height="100" rx="2" fill="#f0ebe0" stroke="#d0c8b8"
                      strokeWidth="0.5"/>
                {/* Tower */}
                <rect x="314" y="100" width="52" height="60" rx="2" fill="#e8e0d0" stroke="#d0c8b8" strokeWidth="0.5"/>
                {/* Roof */}
                <polygon points="304,100 376,100 340,65" fill="#8b3a3a"/>
                {/* Cross */}
                <line x1="340" y1="50" x2="340" y2="70" stroke="#c8a84b" strokeWidth="3" strokeLinecap="round"/>
                <line x1="330" y1="57" x2="350" y2="57" stroke="#c8a84b" strokeWidth="3" strokeLinecap="round"/>
                {/* Tower windows */}
                <rect x="328" y="112" width="12" height="18" rx="6" fill="#b8d4e8" stroke="#90b0c8" strokeWidth="0.5"/>
                <rect x="344" y="112" width="12" height="18" rx="6" fill="#b8d4e8" stroke="#90b0c8" strokeWidth="0.5"/>
                {/* Rose window */}
                <circle cx="340" cy="164" r="14" fill="none" stroke="#d0c8b8" strokeWidth="0.5"/>
                <circle cx="340" cy="164" r="10" fill="#c8d8e8" stroke="#90b0c8" strokeWidth="0.5"/>
                <line x1="340" y1="154" x2="340" y2="174" stroke="#a0b8c8" strokeWidth="0.5"/>
                <line x1="330" y1="164" x2="350" y2="164" stroke="#a0b8c8" strokeWidth="0.5"/>
                {/* Door */}
                <rect x="324" y="196" width="32" height="44" rx="16" fill="#4a3020" stroke="#3a2418" strokeWidth="0.5"/>
                <path d="M324,210 Q340,196 356,210" fill="none" stroke="#6a4a30" strokeWidth="0.5"/>
                {/* Side windows */}
                <rect x="282" y="160" width="14" height="20" rx="7" fill="#b8d4e8" stroke="#90b0c8" strokeWidth="0.5"/>
                <rect x="384" y="160" width="14" height="20" rx="7" fill="#b8d4e8" stroke="#90b0c8" strokeWidth="0.5"/>
                {/* Magnifying glass */}
                <circle cx="430" cy="195" r="26" fill="none" stroke="#9a9a9a" strokeWidth="3"/>
                <line x1="449" y1="214" x2="465" y2="230" stroke="#9a9a9a" strokeWidth="4" strokeLinecap="round"/>
                <line x1="421" y1="186" x2="439" y2="204" stroke="#c0a0a0" strokeWidth="2" strokeLinecap="round"/>
                <line x1="439" y1="186" x2="421" y2="204" stroke="#c0a0a0" strokeWidth="2" strokeLinecap="round"/>
                {/* Ground */}
                <line x1="200" y1="240" x2="480" y2="240" stroke="#d8d0c0" strokeWidth="1" strokeDasharray="4,4"/>
                {/* Bushes */}
                <ellipse cx="262" cy="238" rx="18" ry="10" fill="#7a9a6a"/>
                <ellipse cx="250" cy="234" rx="12" ry="8" fill="#8aaa7a"/>
                <ellipse cx="418" cy="238" rx="18" ry="10" fill="#7a9a6a"/>
                <ellipse cx="430" cy="234" rx="12" ry="8" fill="#8aaa7a"/>
            </svg>
            <p style={{margin: '4px 0 2px', fontWeight: 500, fontSize: 15, color: 'var(--color-text-primary)'}}>
                {t('no results found')}
            </p>
            <p style={{margin: 0, fontSize: 13, color: 'var(--color-text-secondary)'}}>
                {t('try searching with different keywords')}
            </p>
        </div>
    )
}


export const EmptyHolderWithAction = ({
                                          icon,
                                          title,
                                          description,
                                          action,
                                          labelAction,
                                          className,
                                      }) => {
    const t = useTranslate()
    return (
        <div className={classNames("p-3 border border-color-50 rounded-md flex flex-col flex-center gap-1", className)}>
            {title && (
                <span className="font-semibold text-base text-color-100 tracking-wide leading-snug">
              {t(title)}
            </span>
            )}
            {description && (
                <span className="text-center text-sm text-color-500 italic tracking-wider">
              {t(description)}
            </span>
            )}
            <span onClick={action}
                  className="mt-2 font-medium text-xs text-blue-500 hover:text-blue-600 cursor-pointer tracking-wide">
          {icon}
                {t(labelAction)}
        </span>
        </div>
    )
}

export const renderEmptyHolder = (withBorder = true) =>
    withBorder ? (
        <EmptyHolder/>
    ) : (
        <div className="w-full justify-center items-center">
            <EmptyHolder/>
        </div>
    )

export const renderAdminOnlyHolder = (withBorder = true) =>
    withBorder ? (
        <EmptyHolder title={'Admin-Exclusive Content'} subTitle={'This section is accessible only to admins'}/>
    ) : (
        <div className="w-full justify-center items-center">
            <EmptyHolder title={'Admin-Exclusive Content'} subTitle={'This section is accessible only to admins'}/>
        </div>
    )

export default EmptyHolder
